/**
 * @author Huangxiaoxun<hxx09448@gmail.com>
 * @date 2019/1/17
 */

import { getRunTime } from '../../libs/utils/index'
import { getPlatform } from '../../../frontend-lib/tools/getPlatform'
import { loadScript } from '../../libs/utils/index'

export default class AliVerif {
  /**
   *
   * @param ele 需要插入的dom元素
   */
  constructor(ele) {
    this.ele = ele
    this.nc_appKey = 'FFFF000000000182B110'
    this.nc_token = [this.nc_appKey, new Date().getTime(), Math.random()].join(
      ':'
    )
    this.nc_sence = getPlatform().isPc ? 'nc_register' : 'nc_message_h5'
    this.slid_nc = null
    this.nc = null
    // todo:需要在父类中给callback赋值
    this.slid_nc_opt = getPlatform().isPc
      ? {
          renderTo: this.ele,
          appkey: this.nc_appKey,
          scene: this.nc_sence,
          token: this.nc_token,
          customWidth: 250,
          trans: { key1: 'code0' },
          is_Opt: 0,
          language: 'cn',
          isEnabled: true,
          timeout: 3000,
          times: 5,
          apimap: {},
          callback: null
        }
      : {
          renderTo: this.ele,
          appkey: this.nc_appKey,
          scene: this.nc_sence,
          token: this.nc_token,
          trans: { key1: 'code0' },
          elementID: ['usernameID'],
          is_Opt: 0,
          language: 'cn',
          timeout: 10000,
          retryTimes: 5,
          errorTimes: 5,
          inline: false,
          apimap: {},
          bannerHidden: false,
          initHidden: false,
          callback: null
        }
    this.loadNc()
  }

  /**
   *
   * @param slid_nc_opt 在父类赋值callback后作为参数传入
   */
  initNc(slid_nc_opt) {
    console.log('opt', slid_nc_opt)
    if (getPlatform().isPc) {
      this.slid_nc = new noCaptcha(slid_nc_opt)
      this.slid_nc.upLang('cn', {
        _startTEXT: '请按住滑块，拖动到最右边',
        _yesTEXT: '验证通过',
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork:
          '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
      })
    } else {
      this.nc = NoCaptcha.init(slid_nc_opt)
      NoCaptcha.setEnabled(true)
      this.nc.reset() // 请务必确保这里调用一次reset()方法
      NoCaptcha.upLang('cn', {
        LOADING: '加载中...', // 加载
        SLIDER_LABEL: '请向右滑动验证', // 等待滑动
        CHECK_Y: '验证通过', // 通过
        ERROR_TITLE: '非常抱歉，这出错了...', // 拦截
        CHECK_N: '验证未通过', // 准备唤醒二次验证
        OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码', // 二次验证
        TIPS_TITLE: '验证码错误，请重新输入' // 验证码输错时的提示
      })
    }
  }

  getTimeStamp() {
    let today = new Date()
    const timeStamp = `${today.getFullYear()}${today.getMonth() +
      1}${today.getDay()}`
    return timeStamp
  }

  async loadNc() {
    const loadUrl = getPlatform().isPc
      ? `//g.alicdn.com/sd/ncpc/nc.js`
      : `//g.alicdn.com/sd/nch5/index.js`
    try {
      await loadScript(`${loadUrl}?t=${this.getTimeStamp()}`, () => {
        console.log('load完成')
      })
    } catch (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/AliVerif/index.js